import { httpHandlerAxios } from '../internal/httpHandlerAxios'

export const httpHandler = httpHandlerAxios
